import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import LoginPage from "./pages/login_register/LoginPage";
import { Layout } from "./components/Layout";
import AccountsList from "./pages/accounts/AccountsList.tsx";
import Trades from "./pages/trades/Trades.tsx";
import EditAccount from "./pages/accounts/EditAccount";
import AddAccount from "./pages/accounts/AddAccount";
import PromptEditor from "./pages/prompt_editor/PromptEditor.tsx";


export const PrivateRoute = ({ redirectPath = "/login", children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};

export const PublicRoutes = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/counter",
    element: <Counter />,
  },
  {
    path: "/fetch-data",
    element: <FetchData />,
  },
];

export const PrivateRoutes = [
  {
    index: true,
    element: (
        <Layout>
            <AccountsList />,
        </Layout>
    ),
    
    },
    {
        path: "/accounts",
        element: (
            <Layout>
                <AccountsList />
            </Layout>
        ),
    },
    {
        path: "/prompt-editor",
        element: (
            <Layout>
                <PromptEditor />
            </Layout>
        ),
    },
    {
        path: "/account/trades/:accountId",
        element: (
            <Layout>
                <Trades />
            </Layout>
        ),
    },
    {
        path: "/accounts/edit/:accountId",
        element: (
            <Layout>
                <EditAccount />
            </Layout>
        ),
    },
    {
        path: "/accounts/new",
        element: (
            <Layout>
                <AddAccount />
            </Layout>
        ),
    },
  //{
  //    path: "/empire_case_opener/:caseId/",
  //    element: (
  //        <Layout>
  //            <EmpireCaseOpener />
  //        </Layout>
  //    ),
  //},
];
